import { useRef } from "react";

const COLORS = { declarado: "#D97706", encontrado: "#DC2626" };

const CarShape = ({ light }) => {
  const stroke = light ? "#334155" : "#64748B";
  const fill = light ? "#F1F5F9" : "#111723";
  return (
    <g fill="none" stroke={stroke} strokeWidth="2">
      <rect x="18" y="38" width="22" height="58" rx="6" fill={stroke} />
      <rect x="160" y="38" width="22" height="58" rx="6" fill={stroke} />
      <rect x="18" y="300" width="22" height="58" rx="6" fill={stroke} />
      <rect x="160" y="300" width="22" height="58" rx="6" fill={stroke} />
      <path d="M60 14 Q100 2 140 14 Q172 24 172 70 L172 340 Q172 384 140 392 Q100 400 60 392 Q28 384 28 340 L28 70 Q28 24 60 14Z" fill={fill} />
      <path d="M50 120 Q100 98 150 120 L142 158 Q100 146 58 158Z" />
      <rect x="58" y="166" width="84" height="110" rx="8" />
      <path d="M58 286 Q100 296 142 286 L148 322 Q100 336 52 322Z" />
      <line x1="28" y1="210" x2="58" y2="210" /><line x1="142" y1="210" x2="172" y2="210" />
      <path d="M28 150 L14 158 L14 172 L28 172" /><path d="M172 150 L186 158 L186 172 L172 172" />
      <line x1="60" y1="40" x2="140" y2="40" strokeDasharray="4 4" />
    </g>
  );
};

export const VehicleDiagram = ({ marks = [], onChange, tipo = "encontrado", light = false }) => {
  const ref = useRef(null);
  const editable = !!onChange;
  const onClick = (e) => {
    if (!editable) return;
    const r = ref.current.getBoundingClientRect();
    const x = +(((e.clientX - r.left) / r.width) * 100).toFixed(1);
    const y = +(((e.clientY - r.top) / r.height) * 100).toFixed(1);
    onChange([...marks, { x, y, tipo, nota: "" }]);
  };
  return (
    <div className="mx-auto w-full max-w-[260px]">
      <p className={`mb-1 text-center font-mono text-[10px] uppercase tracking-widest ${light ? "text-slate-500" : "text-slate-500"}`}>Frente</p>
      <svg ref={ref} viewBox="0 0 200 410" onClick={onClick} data-testid="os-diagram-canvas"
        className={`w-full ${editable ? "cursor-crosshair" : ""}`}>
        <CarShape light={light} />
        {marks.map((m, i) => (
          <g key={i} transform={`translate(${(m.x / 100) * 200} ${(m.y / 100) * 410})`} data-testid={`diagram-mark-${i}`}>
            <circle r="9" fill={COLORS[m.tipo] || COLORS.encontrado} stroke="#fff" strokeWidth="1.5" />
            <text textAnchor="middle" dy="3.5" fontSize="10" fontWeight="700" fill="#fff" fontFamily="JetBrains Mono">{i + 1}</text>
          </g>
        ))}
      </svg>
      <p className="mt-1 text-center font-mono text-[10px] uppercase tracking-widest text-slate-500">Traseira</p>
      <div className="mt-2 flex justify-center gap-4 text-[11px]">
        <span className="flex items-center gap-1.5"><span className="h-2.5 w-2.5 rounded-full" style={{ background: COLORS.declarado }} /><span className={light ? "text-slate-600" : "text-slate-400"}>Declarado</span></span>
        <span className="flex items-center gap-1.5"><span className="h-2.5 w-2.5 rounded-full" style={{ background: COLORS.encontrado }} /><span className={light ? "text-slate-600" : "text-slate-400"}>Encontrado na inspeção</span></span>
      </div>
    </div>
  );
};
